import { styled } from '@mui/material'
import { TreeItem } from '@mui/x-tree-view'

export const StyledTreeItem = styled(TreeItem)(
    ({ theme, radioSelection, selected, isParentSelected }) => ({
        '&:focus > .MuiTreeItem-content': {
            backgroundColor: 'inherit',
        },
        zIndex: 2000,
        '&:hover': {
            backgroundColor: 'inherit',
        },
        '& .MuiTreeItem-iconContainer': {
            '& .close': {
                opacity: 0.3,
            },
        },
        '& .MuiTreeItem-group': {
            marginLeft: 12,
            borderLeft: '1px dotted #eef0f4',
        },
        '& .MuiTreeItem-content': {
            marginBottom: '6px',
            marginTop: '6px',
            '&:hover': {
                backgroundColor: 'inherit',
            },
        },
        '& .MuiTreeItem-label': {
            color: radioSelection
                ? selected
                    ? '#000000'
                    : '#767676'
                : selected
                ? '#00bb75'
                : '#3b454d',
            width: 'max-content',
            borderRadius: '5px',
            backgroundColor: !radioSelection && 'unset !important',
            opacity: !radioSelection && isParentSelected ? 0.4 : 1,
            marginLeft: !radioSelection && '3px',
            border: !radioSelection && selected ? 'solid 1px #00bb75' : 'none',
            padding: radioSelection ? '5px' : '0px',
            '&:hover': {
                backgroundColor: '#f1f1f4 !important',
            },
            '& .search-highlight': {
                color: '#01745f',
                fontWeight: 600,
                textDecoration: 'underline',
            },
        },
    }),
)
